import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import SectionTitle from '../components/SectionTitle';
import FeatureCard from '../components/FeatureCard';
import { ServerIcon } from 'lucide-react';
const SolutionsPage = () => {
  const solutionCategories = [{
    id: 'all-in-one',
    title: '一体机解决方案',
    description: '集成硬件与软件的一体化部署方案，简化企业AI系统搭建流程，提供即插即用的便捷体验。',
    icon: <ServerIcon className="h-12 w-12" data-id="element-627" />,
    image: 'https://images.unsplash.com/photo-1563770660941-10a63607692e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    solutions: [{
      id: 'office',
      title: '智能办公一体机解决方案',
      description: '集成文档处理、会议助手、智能翻译等功能，全面提升办公效率和体验。'
    }, {
      id: 'deepseek',
      title: 'Deepseek一体机解决方案',
      description: '基于Deepseek大模型的专用一体机，提供强大的AI能力和优化的用户体验。'
    }, {
      id: 'code',
      title: '代码生成一体机解决方案',
      description: '专为软件开发团队设计，提供代码生成、代码审查和优化建议等功能。'
    }]
  }, {
    id: 'embodied',
    title: '具身智能解决方案',
    description: '结合感知、决策和执行能力，为机器人和智能设备提供完整的智能系统解决方案。',
    icon: <div className="h-12 w-12" data-id="element-628" />,
    image: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    solutions: [{
      id: 'simulation',
      title: '具深智能仿真平台',
      description: '提供高精度的物理仿真环境，加速机器人和智能设备的训练和测试过程。'
    }, {
      id: 'humanoid',
      title: '人形机器人解决方案',
      description: '为人形机器人提供先进的控制系统和智能决策能力，实现复杂任务执行。'
    }]
  }, {
    id: 'chips',
    title: '国产AI芯片解决方案',
    description: '基于国产AI芯片的定制化解决方案，提供高性能、低功耗的计算能力，支持各类AI应用场景。',
    icon: <div className="h-12 w-12" data-id="element-629" />,
    image: 'https://images.unsplash.com/photo-1518770660967-092793a63714?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    solutions: [{
      id: 'robot-dog',
      title: '四足机器狗解决方案',
      description: '基于国产AI芯片的四足机器人解决方案，适用于巡检、搜救等复杂环境应用。'
    }, {
      id: 'performance',
      title: '国产化AI芯片性能测试解决方案',
      description: '全面评估国产AI芯片性能的测试方案，提供详细的性能报告和优化建议。'
    }, {
      id: 'cluster',
      title: '国产化异构集群解决方案',
      description: '基于多种国产AI芯片构建的高性能计算集群，满足大规模AI训练和推理需求。'
    }]
  }];
  return <div className="bg-white" data-id="element-630">
      <HeroSection title="解决方案" subtitle="针对不同行业和场景，我们提供定制化的AI解决方案，助力企业创新发展" backgroundImage="https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80" size="medium" data-id="element-631" />
      <section className="py-16 md:py-24" data-id="element-632">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-633">
          <SectionTitle title="我们的解决方案" subtitle="为企业提供全面的AI技术解决方案，助力数字化转型和智能化升级" data-id="element-634" />
          <div className="space-y-20" data-id="element-635">
            {solutionCategories.map((category, index) => <div key={category.id} className="space-y-8" data-id="element-636">
                <div className={`flex flex-col ${index % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-8 items-center`} data-id="element-637">
                  <div className="w-full md:w-1/2" data-id="element-638">
                    <img src={category.image} alt={category.title} className="w-full h-auto rounded-lg shadow-lg" data-id="element-639" />
                  </div>
                  <div className="w-full md:w-1/2" data-id="element-640">
                    <div className="text-primary-500 mb-4" data-id="element-641">{category.icon}</div>
                    <h3 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-642">
                      {category.title}
                    </h3>
                    <p className="text-lg text-gray-600 mb-6" data-id="element-643">
                      {category.description}
                    </p>
                    <Link to={`/solutions/${category.id}`} className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-medium py-2 px-6 rounded-md transition duration-300" data-id="element-644">
                      了解更多
                    </Link>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8" data-id="element-645">
                  {category.solutions.map(solution => <FeatureCard key={solution.id} title={solution.title} description={solution.description} variant="bordered" link={`/solutions/${category.id}/${solution.id}`} data-id="element-646" />)}
                </div>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-647">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-648">
          <SectionTitle title="行业应用" subtitle="我们的解决方案已在多个行业成功应用，为企业带来显著价值" data-id="element-649" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-650">
            <div className="bg-white p-8 rounded-lg border border-gray-200 hover:border-primary-500 transition-colors duration-300 text-center" data-id="element-651">
              <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-652">
                <svg className="w-8 h-8 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-653">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-654"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-gray-900" data-id="element-655">
                金融行业
              </h3>
              <p className="text-gray-600" data-id="element-656">
                智能风控、量化交易、智能投顾、反欺诈系统
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg border border-gray-200 hover:border-primary-500 transition-colors duration-300 text-center" data-id="element-657">
              <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-658">
                <svg className="w-8 h-8 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-659">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" data-id="element-660"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-gray-900" data-id="element-661">
                医疗健康
              </h3>
              <p className="text-gray-600" data-id="element-662">
                医疗影像诊断、智能问诊、药物研发、健康管理
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg border border-gray-200 hover:border-primary-500 transition-colors duration-300 text-center" data-id="element-663">
              <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-664">
                <svg className="w-8 h-8 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-665">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" data-id="element-666"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-gray-900" data-id="element-667">
                制造业
              </h3>
              <p className="text-gray-600" data-id="element-668">
                智能工厂、质量检测、设备预测性维护、供应链优化
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg border border-gray-200 hover:border-primary-500 transition-colors duration-300 text-center" data-id="element-669">
              <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-670">
                <svg className="w-8 h-8 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-671">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-672"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-gray-900" data-id="element-673">
                政企服务
              </h3>
              <p className="text-gray-600" data-id="element-674">
                智能客服、文档分析、舆情监测、智能决策辅助
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 md:py-24" data-id="element-675">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-676">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-677">
            需要定制化解决方案？
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-678">
            根据您的业务需求，我们可以提供量身定制的AI解决方案，帮助您解决特定的业务挑战。
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-679">
            <Link to="/about/contact" className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 px-8 rounded-md transition duration-300" data-id="element-680">
              联系我们
            </Link>
            <Link to="/cases" className="inline-block bg-white text-primary-600 font-medium py-3 px-8 rounded-md border border-primary-600 transition duration-300 hover:bg-primary-50" data-id="element-681">
              查看成功案例
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
export default SolutionsPage;